import React from 'react';

import Button from "./Button"
import TextInput from "./TextInput"
import Card from "./Card"

function ControlPanel({handleAddExercise, handleSave, handleClear, handleLoad, handleAddDate}) {
  return (
    <Card color="bg-light-green">
      <TextInput
        placeholder="Add Weights Exercise"
        onSubmit={(name) => handleAddExercise("weights", name)} />
      <TextInput
        placeholder="Add Cardio Exercise"
        onSubmit={(name) => handleAddExercise("cardio", name)} />
      <div className="flex flex-wrap justify-center">
        <Button className="bg-dark-green w-25" onClick={handleAddDate} text="New Day" />
      </div>
    </Card>
  )
}

export default ControlPanel;